import { render } from "./FinesPoints.vue?vue&type=template&id=8c902d6e&scoped=true"
import script from "./FinesPoints.vue?vue&type=script&lang=js"
export * from "./FinesPoints.vue?vue&type=script&lang=js"

import "./FinesPoints.vue?vue&type=style&index=0&id=8c902d6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c902d6e"]])

export default __exports__